export default "__VITE_ASSET__BvWS8tnY__"